import { IAboutSdelkaItemProps } from '../../../components/AboutSdelka/AboutSdelkaItem';

import iconSrc1 from './assets/icon1.svg';
import iconSrc2 from './assets/icon2.svg';
import iconSrc3 from './assets/icon3.svg';
import { Label } from '@cian/ui-kit';
import { IApplicationContext } from '../../../types/applicationContext';
import { IAboutSdelkaLayoutProps } from '../../../components/AboutSdelka';

export const ABOUT_SDELKA_ITEMS: IAboutSdelkaItemProps[] = [
  {
    icon: iconSrc1,
    title: 'Надёжный эксперт',
    description:
      'Аналитика рынка, юридическое сопровождение, организация просмотров или показов — с вами будет работать не просто риелтор, а специалист на все случаи жизни',
  },
  {
    icon: iconSrc2,
    title: 'Сделка без рисков',
    label: (
      <Label color="text-positive-default" background="surface-positive-hovered">
        Юридическое сопровождение
      </Label>
    ),
    description:
      'Проверим объект и участников сделки, если увидим риски — предложим решение и защитим от потери квартиры в будущем',
  },
  {
    icon: iconSrc3,
    title: 'Контроль качества от Циана',
    description: 'Следим за процессом и подключимся, если понадобится помощь или что-то пойдёт не так',
  },
];

export const getAboutSdelkaHeading = (pageType: IApplicationContext['custom']['pageType']): IAboutSdelkaLayoutProps => {
  if (pageType === 'referral') {
    return {
      title: 'Как вам помогут',
      description:
        'Присоединяйтесь к программе Сделка на Циане: подберём специалиста под ваш запрос и проконтролируем, чтобы всё прошло гладко',
    };
  }

  return {
    title: 'Будем рядом на всех этапах',
  };
};
